<div class="form-group">
    <label class="input-label">Max length</label>
    <input class="form-control"
           name="required"
           type="number"
           [(ngModel)]="fieldOptions.validate.maxLength">
</div>